import React, { useEffect, useState } from "react";
import { getFiatHoldState, subscribeFiatHold } from "../../api/services/fiatHoldStore";
import "./fiatHoldBanner.css";

function formatUntil(heldUntil) {
  if (!heldUntil) return "";
  const d = new Date(heldUntil);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return d.toISOString();
  }
}

export function useFiatHold() {
  const [hold, setHold] = useState(getFiatHoldState);
  useEffect(() => subscribeFiatHold(setHold), []);
  return hold;
}

export default function FiatHoldBanner({ className = "" }) {
  const hold = useFiatHold();

  if (!hold.held) return null;

  const until = formatUntil(hold.heldUntil);
  return (
    <div className={`fiat-hold-banner ${className}`.trim()} role="status">
      <strong>Fiat paused.</strong>
      <span>{hold.message}</span>
      {hold.holdReason ? <span>{hold.holdReason}</span> : null}
      {until ? <span>Until {until}</span> : null}
    </div>
  );
}
